import moment from 'moment';

import withOptions from 'utils/functions/withOptions.util';

const calculateMinutesToNextQuarter = (currentMinutes) => 15 - (currentMinutes % 15);
const currentMinutes = () => moment().minutes();

// TODO: in desperate need of refactoring for clarity and avoiding hidden bugs
const recalculateQuickAppointmentHours = withOptions((options) => {
  const config = Object.assign({}, options);

  config.appointments = config.appointments.map((appointment) => {
    const newAppointment = Object.assign({}, appointment);
    let currentTime;
    if (!appointment.special) {
      currentTime = moment(`${moment().format('DD-MM-YYYY')} ${appointment.start_hour}`, 'DD-MM-YYYY HH-mm');
    } else {
      const splitSpecial = appointment.special.split(' ');
      currentTime = moment().add(splitSpecial[0], splitSpecial[1]).add(calculateMinutesToNextQuarter(currentMinutes()), 'minutes');
    }

    newAppointment.procedures = appointment.procedures.map((procedure) => {
      const newProcedure = Object.assign({}, procedure);
      newProcedure.start_time = currentTime.toISOString();
      currentTime.add(procedure.duration_minutes, 'minutes');

      newProcedure.duration_minutes = undefined;
      return newProcedure;
    });

    newAppointment.start_hour = undefined;
    newAppointment.special = undefined;
    return newAppointment;
  });

  config.times_off = config.times_off.map((timeOff) => {
    const newTimeOff = Object.assign({}, timeOff);
    const currentTime = moment(`${moment().format('DD-MM-YYYY')} ${timeOff.start_hour}`, 'DD-MM-YYYY HH-mm');
    newTimeOff.start_time = currentTime.toISOString();
    currentTime.add(timeOff.duration_minutes, 'minutes');
    newTimeOff.end_time = currentTime.toISOString();

    return newTimeOff;
  });

  return config;
});

export default recalculateQuickAppointmentHours;
